import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { hasSuperAdminToken } from '../../utils/superAdminToken';

interface Props {
    component: React.ComponentType<any>;
    exact?: boolean;
    path?: string | string[];
    [key: string]: any;
}

/**
 * Gate for super-admin routes. Redirects to /mika/ops/login when the
 * sa_access_token is missing. Intentionally parallel to `Protected` but
 * reads from sessionStorage so tenant auth and super-admin auth are isolated.
 */
export const RequireSuperAdmin: React.FC<Props> = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={props =>
                hasSuperAdminToken() ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: '/mika/ops/login',
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    );
};

export default RequireSuperAdmin;
